import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ImageConfig } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';

import { CarrentalComponent } from './carrental/carrental.component';
import { EmailTemp2Component } from './email-temp2/email-temp2.component';
import { EmailTemp3Component } from './email-temp3/email-temp3.component';
import { EmailTemp4Component } from './email-temp4/email-temp4.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { HeaderInterceptor } from './interceptors/header';
import { GlobalErrorHandler } from './global-error-handler';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SignInModule} from "./accounts/sign-in.module";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { HeaderMobileComponent } from './header-mobile/header-mobile.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AnalysisComponent } from './analysis/analysis.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';


const route: Routes = [
]

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    HeaderMobileComponent,
    UserProfileComponent,
    ChatWidgetComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    RouterModule.forChild(route),
    BrowserAnimationsModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    ToastrModule.forRoot({
      timeOut: 6000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
